export const getLocale = () => localStorage.getItem("tj_locale") || undefined;

export const setLocaleStorage = (l) => {
  if (l) localStorage.setItem("tj_locale", l);
  else localStorage.removeItem("tj_locale");
};

export const fmtNum = (n, max = 6, min = 0) =>
  n == null ? "—" : Number(n).toLocaleString(getLocale(), { maximumFractionDigits: max, minimumFractionDigits: min });

export const fmtDateTime = (d, opts = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) =>
  d ? new Date(d).toLocaleString(getLocale(), opts) : "—";

export const LOCALES = [
  { id: "en-US", label: "English (US) — 1,216.67" },
  { id: "en-GB", label: "English (UK) — 1,216.67" },
  { id: "nl-NL", label: "Nederlands — 1.216,67" },
  { id: "de-DE", label: "Deutsch — 1.216,67" },
  { id: "fr-FR", label: "Français — 1 216,67" },
  { id: "es-ES", label: "Español — 1.216,67" },
];
